/*
 * @Description:
 * @Author: PF
 * @Date: 2026-01-07 14:59:47
 * @LastEditors: PF
 * @LastEditTime: 2026-02-27 09:37:42
 */
import { createStore } from 'vuex'

export default createStore({
  state: {
    menuPath: '/',
    menuTree: [],
  },
  getters: {
    getMenuPath (state) {
      return state.menuPath
    },
    getMenuTree (state) {
      console.log(state)
      return state.menuTree
    },
  },
  mutations: {
    setMenuPath (state, menuPath) {
      state.menuPath = menuPath
    },
    setMenuTree (state, menuTree) {
      state.menuTree = menuTree
    },
  },
  actions: {
  },
  modules: {
  }
})
